import { Image } from "./image";
import React from "react";
import { t } from "../data/locale";

export const Usecases = (props) => {
  return (
    <div id="usecases" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{t("usecasesTitle")}</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-sm-6 col-md-4 col-lg-4"
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
